import { APPLICATION_GROUP_BY, Route } from '@/core/entities/types/routes';
import { createRouteLoaderPageDetails } from '@/core/utils/routes.utils';
import Main from '@/core/views/main/main';
import { LEAD_INDICATION_PAGE } from '@/modules/leadIndication/entities/leadIndication.const';
import { VITTA_SUBSCRIPTION_PERMISSION } from '@/modules/leadIndication/entities/leadIndication.enum';
import List from '@/modules/leadIndication/pages/list/list';
import { USER_TYPE } from '@/services/users/endpoints/users';

export enum ROUTE_SUBSCRIPTION_INDICATION {
  LIST = 'subscription-indication-list',
  DETAIL = 'subscription-indication-detail',
  CREATE = 'subscription-indication-create',
}

export const subscriptionIndicationsRoutes: Route[] = [
  {
    path: 'lead-indications',
    Component: Main,
    id: ROUTE_SUBSCRIPTION_INDICATION.LIST,
    meta: {
      groupedBy: APPLICATION_GROUP_BY.BROKER,
      showApplicationMenu: true,
      icon: LEAD_INDICATION_PAGE.ICON,
      nameMenu: LEAD_INDICATION_PAGE.MENU_NAME,
      permission: {
        type: USER_TYPE.BROKER,
        values: [
          VITTA_SUBSCRIPTION_PERMISSION.READ
        ]
      },
    },
    loader() {
      return createRouteLoaderPageDetails({
        title: LEAD_INDICATION_PAGE.TITLE,
        groupedBy: APPLICATION_GROUP_BY.BROKER,
      });
    },
    children: [
      {
        index: true,
        Component: List,
      },
    ],
  },
];

export default subscriptionIndicationsRoutes;
